<template>

           <div class="container">
                <div class="page-header">
                    <div class="page-title">
                   
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'الاشتعارات'" :to="{name: 'notifications'}"> الاشعارات</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                          جميع البيانات 
                                        <create-button  v-if="hasPermissions('parents_create')" :routeName="'parents.create'"></create-button>

                                        </h4>
                                    </div>          
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                               
                                <div class="table-responsive">
                                    <table class="table table-striped table-bordered">
                                      <tbody>
                                       

                                        <tr>
                                          <th>
                                            العنوان
                                          </th>
                                          <td>
                                            {{ notification.title }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <th>
                                             النص
                                          </th>
                                          <td>
                                            {{ notification.content }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            الرد
                                          </th>
                                          <td>
                                            <textarea name="msg" class="form-control" v-model="msg" cols="30" rows="10" placeholder="الرد على الرسالة"></textarea>
                                            <button type="button" class="btn btn-success mt-2" @click.prevent="replyMsg()">ارسال</button>
                                            <div class="alert alert-success text-center mt-2" v-if="msgSent">{{ msgSent }}</div>
                                          </td>
                                        </tr>

                                     
                                      </tbody>
                                    </table>

                                    <hr>
<hr>
                           <table class="table table-striped table-bordered mt-3">
                             <tbody>
                              <tr>
                                <th colspan="4" class="text-danger">الردود</th>
                              </tr>
                              <tr>
                                <th>العنوان</th>
                                <th>النص</th>
                                <th>تاريخ الارسال</th>
                              </tr>
                               <tr v-for="(rep, k) in notification.replies" :key="k">
                                 <th>
                                   {{ rep.title }}
                                 </th>
                                 <td>
                                   {{ rep.content }}
                                 </td>
                                 <td>
                                  {{ rep.creation_date  }}
                                 </td>
                               </tr>
         
                             </tbody>
                           </table>
                                </div>

                                
                               
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
            </div>

</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      notification: {},
      isRequested: false,
      msg: '',
      msgSent: ''
    };
  },
  created() {
    // this.findOne();
  },
  methods: {
    findOne() {
      this.$baseApi.get('/notifications/' + this.$route.params.id).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.notification = response.data.data.notification;
          this.notification.id = this.$route.params.id;
          this.updateNotifications();
        } else if (response.data.code === 404) {
          router.push('/notifications');
        } else {
          alert(response.data.error);
          router.push('/notifications');
        }
      });
    },
    updateNotifications(){
      this.$baseApi.get('/new-notifications').then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
            let resp = response.data.data;
            this.$store.dispatch('SET_NOTIFICATION_COUNT', resp.count);
            this.$store.dispatch('SET_NOTIFICATION_DATA', resp.data);
        }
      });
    },
    replyMsg(){
      this.msgSent = '';
      this.$baseApi.post('/notifications/' + this.$route.params.id, {msg: this.msg}).then((response)=>{
            if(response.data.code === 200){
              this.msgSent = 'تم ارسال رسالتك بنجاح';
              this.msg     = '';
            }
        });
    },
    deleteData(data){
      router.push('/users');
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    }
  }
}

</script>
<style>
</style>
